/**
 * Boy Group (OLYMPUS is RISING) stays off the website until the app opens it:
 * 12:00 AM Eastern on November 1, 2026. That instant is 04:00 UTC (still EDT;
 * daylight saving ends at 2:00 AM that morning). Same cutoff as the app.
 */
export const BOY_GROUP_OPENS_AT_MS = Date.parse("2026-11-01T04:00:00.000Z");

export function isBoyGroupContestOpen(now = Date.now()) {
  const time = now instanceof Date ? now.getTime() : now;
  return time >= BOY_GROUP_OPENS_AT_MS;
}
